import React, { Component } from 'react'
import { fetchSessions, fetchSessionsByDate } from '../actions/sessions.js'

import Loader from 'react-loader-advanced'
import PropTypes from 'prop-types'
import SessionMenu from '../components/Session/SessionMenu.js'
import SessionTable from '../components/Session/SessionTable.js'
import { compose } from 'redux'
import { connect } from 'react-redux'
import filter from 'lodash/filter'
import { setActiveSession } from '../actions/application.js'
import { setBreadCrumbs } from '../actions/breadcrumbs.js'
import { withKeycloak } from '@react-keycloak/web'

class SessionsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sessions: props.sessions,
      filtered: props.sessions,
      isFiltered: false,
      startDate: props.startDate,
      endDate: props.endDate,
    }
    this.filterByBeamline = this.filterByBeamline.bind(this)
  }

  filterByBeamline(beamlines) {
    if (beamlines.length === 0) {
      this.setState({
        filtered: this.state.sessions,
        isFiltered: true,
      })
    } else {
      const sessions = { ...this.state.sessions }
      sessions.data = filter(sessions.data, function (o) {
        for (let i = 0; i < beamlines.length; i++) {
          if (beamlines[i].toUpperCase().trim() === o.beamLineName.toUpperCase().trim()) {
            return true
          }
        }
        return false
      })
      this.setState({
        filtered: sessions,
        isFiltered: true,
      })
    }
  }

  render() {
    let sessions = this.props.sessions
    if (this.state.isFiltered) {
      sessions = this.state.filtered
    }

    if (!this.props.user || !this.props.user.token || !this.props.sessions) {
      return null
    }
    return (
      <div>
        <SessionMenu
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          filterByBeamline={this.filterByBeamline}
          beamlines={this.props.configuration.beamlines}
          user={this.props.user}
          history={this.props.history}
          fetchSessionsByDate={this.props.fetchSessionsByDate}
          setBreadCrumbs={this.props.setBreadCrumbs}
        />
        <Loader show={this.props.sessions.fetching}>
          <SessionTable
            history={this.props.history}
            sessions={sessions}
            setActiveSession={this.props.setActiveSession}
            configuration={this.props.configuration}
          />
        </Loader>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    sessions: state.sessions,
    configuration: state.configuration,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSessionsByDate: (server, token, startDate, endDate) =>
      dispatch(fetchSessionsByDate(server, token, startDate, endDate)),
    fetchSessions: (server, token) => dispatch(fetchSessions(server, token)),
    setActiveSession: (sessionId, title) => dispatch(setActiveSession(sessionId, title)),
    setBreadCrumbs: breadCrumbsList => dispatch(setBreadCrumbs(breadCrumbsList)),
  }
}

SessionsContainer.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withKeycloak)(SessionsContainer)
